/**
 * @description This enum reflects `com.qima.platform.domain.enumeration.BrandType`
 */
export enum BrandType {
  BRAND = 'BRAND',
  SERVICE_PROVIDER = 'SERVICE_PROVIDER',
  CLIENT = 'CLIENT',
}
